import {
  datePl,
  reasons,
  statementParts,
  type TerminationData,
} from "@/components/toolkit/termination";
export function TerminationPreview({ data }: { data: TerminationData }) {
  const fallback = (value: string) => value.trim() || "…";
  const safe = {
    ...data,
    policy: fallback(data.policy),
    insurer: fallback(data.insurer),
    otherPolicy: fallback(data.otherPolicy),
    otherInsurer: fallback(data.otherInsurer),
    end: data.end || "rrrr-mm-dd",
    acquisitionDate: data.acquisitionDate || "rrrr-mm-dd",
  };
  return (
    <aside className="studio-preview-stage" aria-label="Podgląd wypowiedzenia">
      <div className="studio-preview-toolbar">
        <span>Podgląd dokumentu</span>
        <span>● Na żywo</span>
      </div>
      <article className="studio-paper">
        <div className="studio-paper-header">
          <img src="/logos/adara-logo.svg" alt="Adara Ubezpieczenia" />
          <span>
            {fallback(data.city)}, {datePl(data.date)}
          </span>
        </div>
        <h2>
          Wypowiedzenie
          <br />
          umowy ubezpieczenia OC
        </h2>
        <p className="studio-paper-sub">
          {reasons[data.reason].title} · {reasons[data.reason].article}
        </p>
        <h3 className="studio-paper-label">Dane właściciela / nabywcy</h3>
        <strong>{fallback(data.name)}</strong>
        <p>{fallback(data.address)}</p>
        {data.coOwners && (
          <p>
            Współwłaściciele: <strong>{data.coOwners}</strong>
          </p>
        )}
        <h3 className="studio-paper-label">Pojazd i polisa</h3>
        <div className="studio-paper-grid">
          <div>
            <small>Marka i model</small>
            <strong>{fallback(`${data.brand} ${data.model}`)}</strong>
          </div>
          <div>
            <small>Numer rejestracyjny</small>
            <strong>{fallback(data.registration)}</strong>
          </div>
          <div>
            <small>Towarzystwo</small>
            <strong>{fallback(data.insurer)}</strong>
          </div>
          <div>
            <small>Numer polisy</small>
            <strong>{fallback(data.policy)}</strong>
          </div>
          <div>
            <small>Okres ochrony</small>
            <strong>
              {datePl(data.start) || "…"} – {datePl(data.end) || "…"}
            </strong>
          </div>
        </div>
        <h3 className="studio-paper-label">Oświadczenie</h3>
        <p className="studio-paper-statement">
          {statementParts(safe).map((part) =>
            part.bold ? <strong key={part.key}>{part.text}</strong> : part.text,
          )}
        </p>
        <div className="studio-paper-sign">
          ________________________________
          <br />
          Podpis właściciela / nabywcy
          <br />
          (współwłaścicieli lub pełnomocnika)
        </div>
      </article>
      <p className="studio-paper-note">
        Podgląd układu. Gotowy PDF pobierzesz po sprawdzeniu danych.
        <br />
        Dokument i dane formularza nie są zapisywane.
      </p>
    </aside>
  );
}
